/**
 * Created by Qingger Corp.
 * User: tanjianzhen
 * Date: 2018-7-7
 * Time: 15:25
 * Desc:
 */
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import collect from 'collect.js';
import { isEmpty } from 'lodash';
import { IPSService } from '@/services/ipsServices';
import { QinggerLibUtils } from '@/util';
const isset = QinggerLibUtils.isset;

@Component({
  components: {},
})
export default class ClassGoodsEdit extends Vue {
  @Prop({ default: [] }) labelList: ItemArray<ComponentsInfo>;
  @Prop({ default: 0 }) pageIndex: number;

  public selectValue = 4;

  public labelIndex = -1;

  public showNumber: Array<any> = [
    {
      value: 2,
      label: '2',
    },
    {
      value: 4,
      label: '4',
    },
    {
      value: 6,
      label: '6',
    },
    {
      value: 8,
      label: '8',
    },
    {
      value: 10,
      label: '10',
    },
  ];

  /* 标签分类列表  api */
  public labelClassList: ItemArray<ProductClassInfo> = [];

  public labelGoodsList: ItemArray<ComponentsInfo> = [];

  /**
   * 选择的数量
   * @param value
   */
  selectNum(value) {
    const self = this;
    self.selectValue = value;
    if (this.labelGoodsList.length > 0) {
      self.labelGoodsList.forEach((item) => {
        item.maxProductNum = self.selectValue;
      });
    }
  }

  /**
   * 选择的下标
   */
  selectIndex(index) {
    this.labelIndex = index;
  }

  /**
   * 选择的标签
   * @param value
   */
  selectLabelClass(value) {
    let className = '';
    this.labelClassList.forEach((item) => {
      if (item.classId == value) {
        className = item.className;
      }
    });
    this.labelGoodsList[this.labelIndex].className = className;
    this.labelGoodsList[this.labelIndex].classId = value;
  }

  /**
   * 添加一个标签分类
   */
  addLabel() {
    const item: ComponentsInfo = {
      classId: 0,
      className: '',
      maxProductNum: this.selectValue,
    };
    this.labelGoodsList.push(item);
  }

  /**
   * 删除一个标签设置
   * @param index
   */
  deleteLabel(index) {
    this.labelGoodsList.splice(index, 1);
  }

  /**
   * 打印拖拽后的图片列表Test
   */
  sortIndex() {
    collect(this.labelGoodsList)
      .map<number>((item, index): any => {
        return item;
      })
      .all();
  }

  public created() {
    console.log('ClassGoodsEdit Created');
    this.labelGoodsList = this.labelList;
    if (!isEmpty(this.labelGoodsList)) {
      this.selectValue = this.labelGoodsList[0].maxProductNum;
    }
    this.getLabelClassList();
  }

  /**
   * 获取标签分类列表 api
   */
  public getLabelClassList(): void {
    this.labelClassList = [];
    const queryParams = {
      sgId: Number.parseInt(this.$route.params.id),
      state: 1,
    };
    IPSService.getLabelClassList({ queryParams }).then((responseData) => {
      if (isset(responseData, 'list')) {
        this.labelClassList = responseData.list;
      }
    });
  }

  public mounted() {}

  @Watch('labelList', { deep: true })
  watchLabelList() {
    this.labelGoodsList = this.labelList;
  }
}
